import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import MobiusPage from "@insite/mobius/Page";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";


const enum fields {
    pageWidth = "pageWidth"
}


interface PageStyles {
    maxWidthOverride?: InjectableCss;
}

interface OwnProps extends PageProps {
    fields:{
        [fields.pageWidth]: string;
    }
}


const Page: React.FunctionComponent<OwnProps> = ({ fields, id }) => {

    const pageStyles: PageStyles = {
        maxWidthOverride: {
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-width: ${fields.pageWidth}%;
                            `,
                        ],
                        "min",
                    )}
            `,
        },
    };


    return(
        <MobiusPage {...pageStyles.maxWidthOverride}>
            <Zone contentId={id} zoneName="Content" requireRows />
            <AddToListModal />
        </MobiusPage>
    )
};

const pageModule: PageModule = {
    component: Page,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                name: "pageWidth",
                fieldType: "General",
                editorTemplate: "TextField",
                displayName: "Page Width (%) e.g. 100 = full width",
                defaultValue: "100",
            },
        ],
    },
};

export default pageModule;
